/**
 * Schermteksten in het Hongaars.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const hu: Teksten = {
  kamerOphalen: "Szoba lekérése…",
  kamerWerktNiet: "Ez a szoba nem működik",
  serverReageertNiet: "A szerver nem válaszol",
  probeerOpnieuw: "Próbáld újra",
  vraagNieuweCode: "Kérj egy új kódot attól, aki megosztotta. A szobák néhány óra után lejárnak.",
  welkeTaalSprekJij: "Milyen nyelven beszélsz?",
  jouwStem: "A hangod a fordításban",
  man: "Férfi",
  vrouw: "Nő",
  pincode: "PIN-kód",
  pincodeUitleg: "Ezt attól kapod meg, aki megosztotta a kódot.",
  gaDeKamerIn: "Lépj be a szobába",
  kiesEerstJeTaal: "Előbb válaszd ki a nyelvedet",
  microfoonAanvragen: "Mikrofon engedélyezése…",
  toestemmingUitleg: "A böngésződ mindjárt engedélyt kér a mikrofonhoz. Enélkül csak gépelni tudsz.",
  microfoonTestLink: "Előbb teszteld a mikrofont",
  stemGaatMee: "Ebben a szobában a másik fél a saját hangodat is hallja a fordítás mellett.",
  alleenChatMelding: "Ez a beszélgetés csak csevegés. Begépeled az üzeneteidet és elolvasod a fordítást; semmi sincs felolvasva.",
  verlooptOm: "Lejárat:",
  nooitVasteKamer: "Soha, állandó szoba",
  kamer: "Szoba",
  tolkgesprek: "Tolmácsolás",
  juisteKamer: "A megfelelő szobában vagy. Mindjárt bekapcsolódhatsz a beszélgetésbe.",
  jij: "te",
  deAnder: "a másik",
  verbinden: "Kapcsolódás…",
  verbonden: "Kapcsolódva",
  verbindingKwijt: "Kapcsolat megszakadt. Újrapróbálkozás…",
  wachtenOpAnder: "Bent vagy. Várj, amíg a másik beolvassa a QR-kódot.",
  allebeiInDeKamer: "Mindketten a szobában vagytok.",
  anderIsWeg: "A másik kilépett",
  anderSpreekt: "A másik beszél…",
  jeKuntErNietIn: "Nem tudsz belépni",
  overgenomenTitel: "Folytatás egy másik eszközön",
  overgenomenUitleg: "Ezt a beszélgetést épp most nyitották meg egy másik eszközön. Ott folytathatod.",
  terug: "Vissza",
  geluidStaatUit: "A hang ki van kapcsolva. Koppints bárhová a képernyőn.",
  tikHier: "koppints ide",
  bewaardTot: 'Megőrizve eddig: {tijd}',
  bewaardVast: "Állandó szoba. Az üzenetek 30 napig megmaradnak.",
  spreekIn: "Beszélj",
  luisteren: "Hallgatás… koppints a leállításhoz",
  uitschrijven: "Leírás…",
  tijdOmTeVerbeteren: "Idő a javításra",
  altijdZelfVersturen: "Mindig magad ellenőrizd és küldd",
  jijVerstuurtZelf: "Te küldöd el",
  uit: "ki",
  sec: "mp",
  vertalingMeteenAfspelen: "Fordítás lejátszása azonnal",
  typHierJeBericht: "Írd ide az üzenetet…",
  stuur: "Küldés",
  geenOpnameMogelijk: "Ez a böngésző nem tud hangot rögzíteni. A gépelés működik.",
  verstaanAls: "Így hallva:",
  tellerStaatStil: "számláló áll",
  versturen: "Küldés",
  wis: "Törlés",
  jijZei: "ezt mondtad",
  vertaald: "lefordítva",
  duimOmhoog: "Ez helyes",
  duimOmlaag: "Ez nem helyes",
  opnieuwProberenKnop: "Újrapróbálás jobb modellel",
  opnieuwProberenBezig: "Újrafordítás…",
  duimTranscriptWoordenlijstUitnodiging: "Félreértette? Javítsd ki a szójegyzékben:",
  instellingenAanpassen: "Beállítások módosítása",
  geldtVoorJullieBeiden: "Mindkettőtökre vonatkozik",
  alleenVoorJou: "Csak neked",
  stuurMijnStemMee: "Saját hangom küldése is",
  verbeterSpelfouten: "Helyesírási hibák javítása a szövegemben",
  verbeterSpelfoutenUit: "Kikapcsolva azt mutatja, ami valóban elhangzott, hibákkal együtt.",
  alleenChat: "Csak csevegés: nincs beszéd, nincs mikrofon",
  alleenChatUitleg: "Mindketten gépeltek. A fordítás és az eredeti szöveg is látható; semmi sincs felolvasva.",
  aangepastDoorDeAnder: "A másik fél módosította a beállításokat.",
  foutSpraak: "A fordítás elkészült, de nem szólalt meg hang.",
  foutSpraakQuota: "A mai hangkeret elfogyott. A szöveg továbbra is működik; a hang holnap visszatér.",
  foutBudgetKamer: "Ez a beszélgetés elérte a keretét, ezért a fordítás szünetel. Aki létrehozta, megemelheti; utána azonnal újra működik.",
  foutBudgetMaand: "Az alkalmazás havi kerete elfogyott. A fordítás akkor működik újra, ha a rendszergazda módosítja.",
  foutTaal: "Ez a nyelv nem használható: mindketten ugyanazt a nyelvet beszélnétek.",
  origineel: "eredeti",
  vertalen: "Fordítás…",
  vertalenMislukt: "A fordítás sikertelen.",
  opnieuwAfspelen: "Fordítás újbóli lejátszása",
  hoorDeAnder: "Hallgasd meg, hogyan mondta a másik",
  woordenlijst: "Biztonsági szójegyzék",
  woordenlijstUitleg: "Az alkalmazás rendszeresen félreért egy nevet vagy szakkifejezést? Rögzítsd itt, hogy mi a helyes.",
  hijHoort: "ezt hallja…",
  jijBedoelt: "te így érted…",
  ookVolgendeGesprekken: "A következő beszélgetésekben is — különben csak most érvényes",
  voegToe: "Hozzáadás",
  bezig: "Folyamatban…",
  lijstNietGeladen: "A listát nem sikerült betölteni.",
  toevoegenMislukt: "A hozzáadás sikertelen.",
  verwijderenMislukt: "A törlés sikertelen.",
  overal: "mindenhol",
  verwijder: "Törlés",
  overDitGesprek: "Erről a beszélgetésről",
  toon: "A fordítás hangneme",
  sfeer: "A beszélgetés hangulata",
  jouwPlek: "A te helyed",
  hoeHetWerkt: "De server schrijft je opname uit en vertaalt hem in één keer. Je eigen stem gaat mee naar de ander.",
  kleinereTekst: "Kisebb szöveg",
  grotereTekst: "Nagyobb szöveg",
  insprekenVerbergen: "Beszéd elrejtése",
  insprekenTonen: "Beszéd megjelenítése",
  toetsenbordVerbergen: "Billentyűzet elrejtése",
  toetsenbordTonen: "Billentyűzet megjelenítése",
  vormAutomatisch: "Automatikus",
  vormInformeel: "Tegezés",
  vormFormeel: "Magázás",
  sfeerNeutraal: "Semleges",
  sfeerZakelijk: "Üzleti",
  sfeerOfficieel: "Hivatalos",
  sfeerVriendschappelijk: "Baráti",
  sfeerPartner: "Partneri",
  foutKamerVol: "Ez a szoba megtelt. Csak két ember fér be.",
  plekBezetTitel: "A helyed foglalt",
  plekBezetUitleg: "Valaki már a te oldaladon ül ebben a beszélgetésben, a te nyelveden. Általában te magad vagy az: a beszélgetés még nyitva van egy másik eszközön vagy egy másik lapon. Zárd be ott, és próbáld újra. Néha másfél perc, mire a hely felszabadul.",
  plekBezetWissel: "Te magad vagy az? Írd be: WISSEL, és a beszélgetés erre az eszközre kerül. A másik eszközön ekkor bezárul.",
  plekBezetKnop: "Áthozás erre az eszközre",
  foutKamerVerlopen: "Ez a szoba lejárt vagy bezárt.",
  foutKamerOnbekend: "Ez a szoba nem létezik.",
  foutPinNodig: "Ehhez a szobához PIN-kód szükséges.",
  foutPinFout: "A PIN-kód nem megfelelő.",
  foutProtocol: "Az alkalmazás és a szerver nem értik egymást. Frissítsd az lapot.",
  foutMicroGeweigerd: "Megtagadtad a mikrofon használatát. Kattints a lakatra a címsorban, és engedélyezd.",
  foutGeenMicro: "Nem található mikrofon. Csatlakoztass egyet, és próbáld újra.",
  foutMicroInGebruik: "A mikrofont egy másik program használja. Zárd be azt, és próbáld újra.",
  foutGeenHttps: "A mikrofon csak biztonságos kapcsolaton működik. Nyisd meg az oldalt https-en keresztül.",
  foutMicroOnbekend: "A mikrofont nem sikerült elindítani.",
  foutNietsOpgenomen: "Semmi sem lett rögzítve. Be van kapcsolva a mikrofonod?",
  foutNietsGehoord: "Semmi hang. Be van kapcsolva a mikrofonod, és elég hangosan beszélsz?",
  foutOpnameTeLang: "A felvétel túl hosszú. Beszélj rövidebb szakaszokban.",
  foutMicroGedempt: "A mikrofonod el van némítva. Kapcsold be, és próbáld újra.",

  // --- microfoontest ---
  micTitel: "Mikrofonteszt",
  micOnderschrift: "Négy teszt egymás után, egyenként öt másodperc. Végig beszélj.",
  micStart: "Teszt indítása",
  micTest1: "1. Csak felismerés",
  micTest2: "2. Csak felvétel",
  micTest3: "3. Együtt — előbb a felvétel",
  micTest4: "4. Együtt — előbb a felismerés",
  micFase1: "1 a 4-ből: csak felismerés — mondj egy rövid mondatot",
  micFase2: "2 a 4-ből: csak felvétel — beszélj tovább",
  micFase3: "3 a 4-ből: előbb felvétel, aztán felismerés — beszélj tovább",
  micFase4: "4 a 4-ből: előbb felismerés, aztán felvétel — beszélj tovább",
  micKlaar: "kész",
  micGehoord: "hallott szöveg",
  micOpnameformaat: "Felvételi formátum",
  micGeen: "nincs",
  micBeveiligd: "Biztonságos kapcsolat",
  micJa: "igen",
  micNee: "NEM",
  micBrowser: "Böngésző",
  micGeenHttps: "https nélkül a böngésző nem adja oda a mikrofont. localhost esetén megengedett.",
  micGeenHerkenning: "Ez a böngésző nem ismer beszédfelismerést.",
  micZegIets: "mondj valamit…",
  micWoordenBinnen: "jönnek a szavak",
  micKonNietStarten: "nem indult el",
  micGeenRecorder: "Ez a böngésző nem ismeri a MediaRecordert.",
  micOpnemen: "felvétel…",
  micNietsOpgenomen: "semmi sem lett rögzítve",
  micGeenMicrofoon: "nincs mikrofon",
  micOpnameEerst: "előbb a felvétel…",
  micHerkenningEerst: "előbb a felismerés…",
  micOpnameStarttNiet: "a felvétel nem indult el",
  micSamenGelukt: "Együtt. Felvétel {kb} kB.",
  micAlleenOpname: "Felvétel igen, felismerés nem.",
  micAlleenHerkenning: "Felismerés igen, felvétel nem.",
  micGeenVanBeide: "Egyik sem.",
  micNetwerkFout: "A beszédfelismerés nem érte el a szervert.",
  micAfgebroken: "A felvétel megszakadt.",
  verslagTitel: "Beszélgetési jegyzőkönyv",
  verslagWie: "Ki",
  verslagOrigineel: "Eredeti",
  verslagVertaling: "Fordítás",
  verslagSpreker: "Beszélő: {x}",
  verslagBerichten: "Üzenetek",
  verslagGemaaktOp: "Készült",
  verslagGeenOpname: "Nem szó szerinti felvétel.",
  verslagNootOrigineel: "Az „Eredeti” az a szöveg, ahogyan az alkalmazás a beszélőt megértette.",
  verslagNootCorrectie: "A helyesírás-javítás be volt kapcsolva: az apró elírásokat kijavította.",
  verslagNootAangepast: "Aki beszélt, elküldés előtt még módosíthatta a szöveget.",
  verslagGesproken: "szóban",
  verslagGetypt: "gépelve",
  verslagMislukt: "A fordítás sikertelen. A másik fél ezt a mondatot nem látta a saját nyelvén.",
  verslagNietKlaar: "A fordítás még nem készült el, amikor ez a jegyzőkönyv készült.",
  verslagVertrouwelijk: "Bizalmas.",
  verslagAlleenDeelnemers: "Ez a jegyzőkönyv egy magánbeszélgetés tartalmát tartalmazza, és csak a résztvevőknek szól.",
  verslagGewist: "A beszélgetés {tijd} után törlődik. Ezután ez a jegyzőkönyv nem készíthető el újra.",
  verslagGewistVast: "Állandó szoba: minden üzenet az elküldése után 30 nappal törlődik. A régebbi üzenetek nem szerepelnek ebben a jegyzőkönyvben.",
};
